/**
 * useAuth — Central-only auth hook.
 *
 * Thin wrapper around useCentralAuth that preserves the legacy interface
 * (user shape with firstName/lastName/role/planTier) for existing consumers.
 * All authentication is now via Central Identity.
 */

import { useCentralAuth } from './useCentralAuth';

interface LegacyUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  planTier?: string;
  accountType?: string;
  organizationId?: string;
}

export function useAuth() {
  const central = useCentralAuth();

  // Map Central user to legacy shape for existing consumers
  const user: LegacyUser | null = central.user
    ? {
        id: central.user.id,
        email: central.user.email,
        firstName: central.user.fullName?.split(' ')[0] || '',
        lastName: central.user.fullName?.split(' ').slice(1).join(' ') || '',
        role: central.workspace?.role || 'member',
        organizationId: central.workspace?.id,
      }
    : null;

  return {
    user,
    token: null, // Tokens are managed by centralAuthSlice
    isAuthenticated: central.isAuthenticated,
    isLoading: central.isLoading || !central.isInitialized,
    logout: central.logout,
  };
}
